module.exports = __webpack_public_path__ + "media/components/weather-icon/static/nightmodrain-ec4586599d22ef19889ee743d5e8c88c.png";